import React from 'react';

type Props = {
  header: string;
  seoText: string;
};

export function SeoTextBlockInternal({ header, seoText }: Props) {
  if (!header && (!seoText || seoText.trim() === '<p></p>')) {
    return null;
  }

  return (
    <div className='mt-[16px] md:mt-[40px] rounded-[16px] bg-light-green-bg p-[20px] md:p-[40px]'>
      {header && <h2 className='text-[18px] mb-[20px] font-semibold'>{header}</h2>}

      <div className='no-tailwind '>
        <div dangerouslySetInnerHTML={{ __html: seoText }}></div>
      </div>
    </div>
  );
}

export const SeoTextBlock = React.memo(SeoTextBlockInternal);
